import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client"; // Correct import statement
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./components/Home/Home";
import SignIn from "./components/auth/SignIn/SignIn";
import SignUp from "./components/auth/SignUp/SignUp";
import TitleRegistration from "./components/TitleRegistration/TitleRegistration";
import VerifyTitle from "./components/VerifyTitle/VerifyTitle";
import ProtectedRoute from "./components/auth/ProtectedRoute/ProtectedRoute";
import Dashboard from "./components/Dashboards/Dashboard";
import SubmitTitle from "./components/SubmitTitle/SubmitTitle";
import UserDashboard from "./components/Dashboards/UserDashboard";
import Titles from "./components/Titles/Titles";
import Guidelines from "./components/Guidelines/Guidelines";

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/guidelines",
        element: <Guidelines />,
      },
      {
        path: "/titles",
        element: <Titles />,
      },
      {
        path: "/verify-title",
        element: <VerifyTitle />,
      },
      {
        path: "/dashboard",
        element: <UserDashboard />,
      },
      {
        element: <ProtectedRoute />, // Wrap protected routes with ProtectedRoute
        children: [
          {
            path: "/dashboard",
            element: <Dashboard />,
          },
          {
            path: "/title-registration",
            element: <TitleRegistration />,
          },
          {
            path: "/verify-title",
            element: <VerifyTitle />,
          },
          {
            path: "/submit-title",
            element: <SubmitTitle />,
          },
        ],
      },
    ],
  },
  {
    path: "/signin",
    element: <SignIn />,
  },
  {
    path: "/signup",
    element: <SignUp />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <RouterProvider router={appRouter}>
    <App />
  </RouterProvider>
);
